// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brands-page {
  background-color: rgba(var(--white));
}
.brands-page__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .brands-page__header {
    padding: 1.75rem 1rem 1.25rem;
    height: 2.5rem;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: rgba(var(--white));
  }
}
.brands-page__content {
  padding: 0 6.875rem 3rem;
}
@media (max-width: 768px) {
  .brands-page__content {
    padding: 0;
  }
}
.brands-page__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .brands-page__title {
    font-size: 1.5rem;
    line-height: 1.3;
    padding: 0 1rem;
    margin-top: 0.75rem;
  }
}
.brands-page__letters {
  display: flex;
  flex-wrap: wrap;
  gap: 2.1875rem;
  margin: 4.5rem 0 5rem;
}
@media (max-width: 768px) {
  .brands-page__letters {
    margin: 2rem 0 2.5rem;
    padding: 0 1rem;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 2rem;
    position: sticky;
    top: 5.5rem;
    background-color: rgba(var(--white));
  }
}
.brands-page__letters-item {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.625;
  font-family: var(--merriweather);
  color: rgba(var(--grey-800));
}
.brands-page__letters-item:last-child {
  margin-left: 0.3125rem;
}
.brands-page__letters-item_disabled {
  color: rgba(var(--grey-400));
  cursor: auto;
}
.brands-page__list {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-bottom: 4.5rem;
}
@media (max-width: 768px) {
  .brands-page__list {
    padding: 0 1rem;
  }
}
.brands-page__list-letter {
  font-weight: 400;
  font-size: 2rem;
  line-height: 1.5;
  font-family: var(--merriweather);
  color: rgba(var(--grey-800));
  margin-bottom: 1.5rem;
}
.brands-page__list-brands {
  display: grid;
  grid-template-columns: repeat(4, 17.1875rem);
  grid-template-rows: repeat(auto-fit, 26px);
  grid-auto-flow: column;
  grid-gap: 1.5rem;
  column-gap: 2.5rem;
  max-height: 476px;
}
@media (max-width: 768px) {
  .brands-page__list-brands {
    column-gap: 0;
    grid-template-columns: auto;
    grid-auto-flow: row;
    max-height: max-content;
  }
}
.brands-page__list-brands-item {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.625;
  color: rgba(var(--grey-800));
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/pages/Brands/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,6BAAA;IACA,cAAA;IACA,gBAAA;IACA,MAAA;IACA,UAAA;IACA,oCAAA;EAEJ;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,UAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AACJ;AACI;EANF;IAOI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AACJ;AACI;EANF;IAOI,qBAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,WAAA;IACA,oCAAA;EAEJ;AACF;AAAI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,4BAAA;AAEN;AAAM;EACE,sBAAA;AAER;AACM;EACE,4BAAA;EACA,YAAA;AACR;AAIE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AAFJ;AAII;EANF;IAOI,eAAA;EADJ;AACF;AAGI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,4BAAA;EACA,qBAAA;AADN;AAII;EACE,aAAA;EACA,4CAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAFN;AAIM;EATF;IAUI,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,uBAAA;EADN;AACF;AAGM;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,0BAAA;AADR","sourcesContent":[".brands-page {\n  background-color: rgba(var(--white));\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      padding: 1.75rem 1rem 1.25rem;\n      height: 2.5rem;\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      background-color: rgba(var(--white));\n    }\n  }\n\n  &__content {\n    padding: 0 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n      padding: 0 1rem;\n      margin-top: 0.75rem;\n    }\n  }\n\n  &__letters {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2.1875rem;\n    margin: 4.5rem 0 5rem;\n\n    @media (max-width: 768px) {\n      margin: 2rem 0 2.5rem;\n      padding: 0 1rem;\n      flex-wrap: nowrap;\n      overflow-x: auto;\n      gap: 2rem;\n      position: sticky;\n      top: 5.5rem;\n      background-color: rgba(var(--white));\n    }\n\n    &-item {\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.625;\n      font-family: var(--merriweather);\n      color: rgba(var(--grey-800));\n\n      &:last-child {\n        margin-left: 0.3125rem;\n      }\n\n      &_disabled {\n        color: rgba(var(--grey-400));\n        cursor: auto;\n      }\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n    margin-bottom: 4.5rem;\n\n    @media (max-width: 768px) {\n      padding: 0 1rem;\n    }\n\n    &-letter {\n      font-weight: 400;\n      font-size: 2rem;\n      line-height: 1.5;\n      font-family: var(--merriweather);\n      color: rgba(var(--grey-800));\n      margin-bottom: 1.5rem;\n    }\n\n    &-brands {\n      display: grid;\n      grid-template-columns: repeat(4, 17.1875rem);\n      grid-template-rows: repeat(auto-fit, 26px);\n      grid-auto-flow: column;\n      grid-gap: 1.5rem;\n      column-gap: 2.5rem;\n      max-height: 476px;\n\n      @media (max-width: 768px) {\n        column-gap: 0;\n        grid-template-columns: auto;\n        grid-auto-flow: row;\n        max-height: max-content;\n      }\n\n      &-item {\n        font-weight: 400;\n        font-size: 1rem;\n        line-height: 1.625;\n        color: rgba(var(--grey-800));\n        text-transform: capitalize;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
